import { render } from "./ContactHero.vue?vue&type=template&id=10bd8d13"
import script from "./ContactHero.vue?vue&type=script&lang=js"
export * from "./ContactHero.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__